








import { Component, Prop, Vue } from 'vue-property-decorator';
import { ViewportState } from "../store/store";
import Viewport from '@/services/ScrollingViewport';
import BrowserDetector from "@/services/BrowserDetector";

@Component({
    computed: {
        viewportState(): ViewportState {
            return Viewport.stateFromRoute(this.$store.state, <string>this.$route.name);
        }
    },
    mounted() {
        let _this = <PanningViewport> this;
        if( _this.width === undefined ) _this.width = 800;
        if( _this.height === undefined ) _this.height = 600;
        //console.log('viewport', _this.width, _this.height);

        BrowserDetector.init();
        let root = window.document.getElementById('app'); // for IE only
        Viewport.register(this.$store.state, this.$refs.viewport, this.$refs.viewportContent, root, _this.width, _this.height);

        let newState: ViewportState = Viewport.stateFromRoute(this.$store.state, <string>this.$route.name);
        Viewport.setPause(newState !== ViewportState.follow);
        Viewport.setHide(newState === ViewportState.hidden);
    },
    destroyed() {
        Viewport.unregister();
    },
    watch: {
        viewportState(newState: ViewportState, oldState: ViewportState): void {
            Viewport.setPause(newState !== ViewportState.follow);
            Viewport.setHide(newState === ViewportState.hidden);
            //console.log('Viewport:', newState);//ViewportState
        }
    }
})
export default class PanningViewport extends Vue {
    @Prop() public width?: number;
    @Prop() public height?: number;
}
